"use client";

import React from "react";
import { useAtomValue } from "jotai";
import { navigationAtom, sidebarVisibilityAtom } from "@/store";
import { MissionType, SiteType, SidebarEnum } from "@/types";
import {
  SharedSettingsSidebar,
  MissionSidebar,
  SiteSidebar,
} from "@/components";
import { useMission } from "@/hooks";

type SidebarProps = {
  missions: MissionType[];
  sites: SiteType[];
};

const filterSites = (data: SiteType[], search: string) => {
  return data.filter((site) => {
    return site.missions.includes(search);
  });
};

function SharedSidebar({ missions, sites }: Readonly<SidebarProps>) {
  const { mission } = useMission();
  const navigation = useAtomValue(navigationAtom);
  const isSidebarVisible = useAtomValue(sidebarVisibilityAtom);

  sites = mission ? filterSites(sites, mission.mission_num2) : sites;

  let component;
  switch (navigation) {
    case SidebarEnum.MISSIONS:
      component = <MissionSidebar data={missions} />;
      break;
    case SidebarEnum.SITES:
      component = <SiteSidebar data={sites} />;
      break;
    case SidebarEnum.SETTINGS:
      component = <SharedSettingsSidebar />;
      break;
  }

  if (isSidebarVisible) {
    return (
      <aside className="block w-full lg:max-w-[360px] border-r bg-background">
        <div className="w-full h-full flex flex-col">{component}</div>
      </aside>
    );
  }

  return null;
}

export { SharedSidebar };
